import logo from './logo.svg';
import './assets/styles/App.css';

function App() {
    return <div className='App'></div>;
}

export default App;
